export const pageConstants = {
  GET_REQUEST: 'PAGE_GET_REQUEST',
  GET_SUCCESS: 'PAGE_GET_SUCCESS',
  GET_FAILURE: 'PAGE_GET_FAILURE',

  UPDATE_REQUEST: 'PAGE_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'PAGE_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'PAGE_UPDATE_FAILURE',
}